import { cloneDeep } from 'lodash';
import { talentCardRoutes } from 'packages/talent/TalentCardRoutes';
function prefixChildRouteNames(route, prefix) {
    if (!route.children) {
        return route;
    }
    route.children.forEach(function (child) {
        child.name = "" + prefix + child.name;
        prefixChildRouteNames(child, prefix);
    });
    return route;
}
export var stageTalentCardRoutes = cloneDeep(talentCardRoutes)
    .map(function (route) {
    route.name = "Stage." + route.name;
    prefixChildRouteNames(route, 'Stage.');
    return route;
});
export var dashboardTalentCardRoutes = cloneDeep(talentCardRoutes)
    .map(function (route) {
    route.name = "Dashboard." + route.name;
    prefixChildRouteNames(route, 'Dashboard.');
    return route;
});
export var trmTalentCardRoutes = cloneDeep(talentCardRoutes)
    .map(function (route) {
    route.name = "CandidatePool." + route.name;
    prefixChildRouteNames(route, 'CandidatePool.');
    return route;
});
